import { AppIntegrationDetails } from "models";

/**
 * Do they have a linked integration
 */
export const hasLinkedIntegration = (data: AppIntegrationDetails): boolean => {

    const isLACRMLinked: boolean = data?.lacrm?.isLinked;
    const isJobberLinked: boolean = data?.jobber?.isLinked;
    const isServiceTitanLinked: boolean = data?.servicetitan?.isLinked;
    const isFieldPulseLinked: boolean = data?.fieldpulse?.isLinked;
    const isHousecallProLinked: boolean = data?.housecallpro?.isLinked;
    const isSurefireLocalLinked: boolean = data?.surefire?.isLinked;

    return isLACRMLinked || isJobberLinked || isServiceTitanLinked || isHousecallProLinked || isSurefireLocalLinked || isFieldPulseLinked;
}